(function(w,d){
  const DEF={siteId:'T3r2Jy',listId:'XmrRnS',source:'BABYGO BF Giveaway',campaign:'Black Friday 2025',minMs:2000,minFillMs:900,revision:'2025-10-15'};
  const rx=/^[^\s@]+@[^\s@]{1,}\.[^\s@]{2,}$/i;
  const sleep=m=>new Promise(r=>setTimeout(r,m));
  const withDelay=(p,m)=>Promise.all([p,sleep(m)]).then(([r])=>r);

  const key=(l,e)=>`klaviyo_sub_${l}:${String(e||'').trim().toLowerCase()}`;
  const getFlag=(l,e)=>{try{return localStorage.getItem(key(l,e))==='1'}catch{return false}};
  const setFlag=(l,e)=>{try{localStorage.setItem(key(l,e),'1')}catch{}};

  const cfgOf=f=>({
    siteId:f.dataset.siteId||DEF.siteId,
    listId:f.dataset.listId||DEF.listId,
    source:f.dataset.source||DEF.source,
    campaign:f.dataset.campaign||DEF.campaign,
    minMs:Number(f.dataset.minSpinnerMs||DEF.minMs),
    minFillMs:Number(f.dataset.minFillMs||DEF.minFillMs),
    revision:f.dataset.revision||DEF.revision
  });

  const payload=(email,cfg)=>({data:{type:'subscription',
    attributes:{profile:{data:{type:'profile',attributes:{
      email:String(email).trim(),
      subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}},
      properties:{source:cfg.source,campaign:cfg.campaign}
    }}}},
    relationships:{list:{data:{type:'list',id:cfg.listId}}}
  }});

  const busy=(btn,on)=>{
    if(!btn) return;
    const t=btn.querySelector('.btn-text');
    const s=btn.querySelector('.btn-spin');
    if(t && !t.dataset.base) t.dataset.base=t.textContent; // save original once
    btn.setAttribute('aria-busy',on);
    if(s){s.hidden=!on; s.setAttribute('aria-hidden',String(!on));}
    if(t){t.textContent=on?'Submitting…':(t.dataset.base||'Submit');}
  };

  // ✅ Updated setMsg() for transitions
  const setMsg=(el,text,isErr)=>{
    if(!el) return;
    el.textContent=text||'';
    if(text){
      el.classList.add('active');
    } else {
      el.classList.remove('active');
    }
    if(isErr){
      el.setAttribute('data-error','1');
    } else {
      el.removeAttribute('data-error');
    }
  };

  async function wire(form){
    if(form.__wired) return; form.__wired=true;
    const cfg=cfgOf(form);
    const emailEl=form.querySelector('.email-signup__input,input[type="email"],[name="email"]');
    const btn=form.querySelector('.email-signup__button,button[type="submit"]');
    const status=form.querySelector('#bf-status,.email-signup__status,[data-signup-status]')||
      (()=>{const p=d.createElement('p');p.className='email-signup__status';p.setAttribute('role','status');form.appendChild(p);return p})();
    const hp=form.querySelector('input[name="company"]');

    let startedAt=0; const start=()=>{ if(!startedAt) startedAt=Date.now(); };
    emailEl?.addEventListener('focus',start,{once:true});
    emailEl?.addEventListener('input',start,{once:true});

    form.addEventListener('submit', async (e)=>{
      e.preventDefault();
      const email=(emailEl?.value||'').trim();

      if(hp && hp.value) return;
      if(!rx.test(email)){ setMsg(status,'Please enter a valid email address.',true); emailEl?.focus(); return; }
      if(Date.now()-startedAt < cfg.minFillMs){ setMsg(status,'Please try again.',true); return; }

      setMsg(status,'');
      busy(btn,true);

      if(getFlag(cfg.listId,email)){
        await sleep(cfg.minMs);
        busy(btn,false);
        setMsg(status,'You’re already on the list — keep an eye on your inbox!');
        return;
      }

      try{
        const req=fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(cfg.siteId)}`,{
          method:'POST',
          headers:{'Content-Type':'application/json','revision':cfg.revision},
          body:JSON.stringify(payload(email,cfg))
        });

        const res=await withDelay(req,cfg.minMs);
        if(!res.ok){
          let m=`Subscription failed (HTTP ${res.status}).`;
          try{
            const j=await res.json();
            const det=(j?.errors&&j.errors[0]?.detail)||j?.message||'';
            if(res.status===409 || /already/i.test(det||'')){
              setFlag(cfg.listId,email);
              busy(btn,false);
              setMsg(status,'You’re already on the list — keep an eye on your inbox!');
              return;
            }
            if(det) m=det;
          }catch{}
          throw new Error(m);
        }

        setFlag(cfg.listId,email);
        busy(btn,false);
        setMsg(status,'You’re all set! Check your inbox for confirmation.');
        form.reset();
        startedAt = 0;

        // GTM Trigger
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'klaviyo_signup_success'
        });

      }catch(err){
        console.error(err);
        busy(btn,false);
        setMsg(status,'Sorry, something went wrong. Please try again.',true);
      }
    });
  }

  const initAll=()=>d.querySelectorAll('form[data-klaviyo-signup], form#bf-email-signup').forEach(wire);
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',initAll); else initAll();

  const mo=new MutationObserver(ms=>ms.forEach(m=>m.addedNodes&&m.addedNodes.forEach(n=>{
    if(n.nodeType===1){
      if(n.matches?.('form[data-klaviyo-signup], form#bf-email-signup')) wire(n);
      n.querySelectorAll?.('form[data-klaviyo-signup], form#bf-email-signup').forEach(wire);
    }
  })));
  mo.observe(d.documentElement,{subtree:true,childList:true});

  w.KlaviyoSignup={initAll,init:wire};
})(window,document);